module.exports = __webpack_public_path__ + "img/890.bb2d6c78.png";